"use client";

import dynamic from "next/dynamic";
import { contactUsData } from "../../data/contactUsData";
import ContactUSForm from "./Home/ContactUsForm";
import Loading from "../../app/loading";
import Loader from "../common/Loader";
import { AnimatedSection } from "../../utils/helpers";
import { ListingItems } from "../common/CommonComponents";
import Link from "next/link";
import Image from "next/image";

const MapComponent = dynamic(() => import("../_pages/contact/EmbeddedMap"), {
  ssr: false,
  loading: () => <Loader />,
});

export const ContactIntro = ({ slope, link, image, introImg, title, title2, title3, icon, data, contentTop, contentBottom }) => {
  const isDirectVideo = link && (
    link.includes("embed-cloudfront.wistia.com/deliveries") ||
    /\.(mp4|webm|ogg)(\?.*)?$/i.test(link)
  );

  const embedLink = !isDirectVideo && (
    link?.includes("youtube.com/watch")
      ? link.replace("watch?v=", "embed/")
      : link?.includes("youtu.be/")
      ? link.replace("youtu.be/", "youtube.com/embed/")
      : link?.match(/^https?:\/\/vimeo\.com\/(\d+)/)
      ? link.replace(/^https?:\/\/vimeo\.com\/(\d+)/, "https://player.vimeo.com/video/$1")
      : link
  );

  return (
    <section id="contact-page">
      <div className="intro pos-rel aarti1">
        {/* {slope ? (
          <div className=" img block">
           <Image
              className="b-r-10"
              src="/images/about/vector.png"
              alt="vector"
              width={500} // set your preferred width
              height={300} // set your preferred height
            />
          </div>
        ) : (
          ""
        )} */}

        <div className="container">
          {/* <div className="row  flex "> */}
          <div className="box t-a-c">
            {link ? (
              <div className="cont-iframe-box">
                <div
                  style={{
                    width: "100%",
                    aspectRatio: "926/368",
                    overflow: "hidden",
                    borderRadius: "10px",
                  }}
                >
                  {isDirectVideo ? (
                    <video
                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                      className="b-r-5"
                      src={link}
                      controls
                      playsInline
                    />
                  ) : (
                  <iframe
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                    }}
                    className="b-r-5"
                    src={embedLink}
                    title="Embedded Content"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                  )}
                </div>
              </div>
            ) : (
              <div className="cont-iframe-box">
                <div className="image-box">
                  <div className="img" style={{ position: "relative", width: "100%", aspectRatio: "926/368", overflow: "hidden", borderRadius: "10px" }}>
                    <Image className="b-r-10" src={introImg} alt={title || "intro"} fill={true} style={{ objectFit: "cover" }} sizes="(max-width: 768px) 100vw, 50vw" />
                  </div>
                </div>
              </div>
            )}
            <div className="cont-iframe-box">
              <div className=" content t-a-c">
                <h1 className="font-barlow f-w-400 t-t-u l-h-1" style={{ color: "#45AFF1", marginTop: 20 }}>
                  {title}
                </h1>
                <h1 className="font-barlow f-w-400 t-t-u l-h-1" style={{ color: "#45AFF1", marginTop: 10 }}>
                  {title3}
                </h1>
                <br />
                <h4 className="font-barlow f-w-300 t-t-u l-h-1-2">{title2}</h4>

                <br />
                <p className=" font-nunito-sans f-w-300 p-18 contact-text" style={{ color: "#fff" }}>
                  {contentTop}
                </p>
                <br />
                <p className=" font-nunito-sans p-18 f-w-300 contact-text" style={{ color: "#fff" }}>
                  {contentBottom}
                </p>
                <br />
                {data ? (
                  <div className=" content-list flex">
                    <div className=" flex-1">
                      <ListingItems data={data} icon={icon} sliceStart={0} sliceEnd={3} />
                    </div>
                    <div className=" flex-1">
                      <ListingItems data={data} icon={icon} sliceStart={3} />
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          {/* <div
              className=" form-box flex-1 "
              style={{
                width: "100%",
              }}
            >
              <ContactUSForm />
            </div> */}
          {/* </div> */}
        </div>
      </div>
    </section>
  );
};

export const ContactInfo = () => {
  return (
    <section id="contact-page">
      <section className="contact-info">
        <div className="schedule-bg" style={{ backgroundImage: "url(/images/contact/contact-bg.png)" }} aria-hidden="true" />

        <div className="container ">
          <div className="row  flex  ">
            <div className="content font-robo  t-a-c">
              {/* <h6 className="f-w-400 ">We'd Love To Hear From You</h6>
              <br /> */}
              <AnimatedSection animation="slideInUp" speed="slow">
                <h6 className="f-w-400 p-20 font-roboto">We'd Love To Hear From You</h6>
                <h2 className="t-t-u p-60 font-robo f-w-400">contact us</h2>
              </AnimatedSection>
              <br />
            </div>

            <div
              className="flex bot  "
              style={{
                zIndex: "11",
              }}
            >
              {contactUsData?.contactInfo?.map((i, index) => (
                <div
                  key={index}
                  className=" flex inner-content    flex-1  "
                  // style={{
                  //   backgroundColor:"orange",
                  //   flexDirection: "column",
                  //   gap: "5px",
                  //   padding: "0 30px",
                  // }}
                >
                  <div
                    className="has-border-top-b col-1-5"
                    // style={{
                    //   borderTop: "10px blue solid",
                    //   height: "10px",
                    //   width: "25%",
                    // }}
                  ></div>
                  <br />
                  <h5 className="font-robo t-t-u f-w-800">{i.title}</h5>

                  <p className=" font-nunito-sans f-w-500 t-a-c">
                    {i.link ? (
                      <Link
                        href={i.link1}
                        className="text-blue-600 hover:underline"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        {i.content1}
                      </Link>
                    ) : (
                      <>{i.content1}</>
                    )}
                  </p>
                  <p className="font-nunito-sans  f-w-600  f-w-600 t-a-c">
                    {i.link ? (
                      <Link
                        href={i.link2}
                        className="text-blue-600 hover:underline"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        {i.content2}
                      </Link>
                    ) : (
                      <>{i.content2}</>
                    )}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export const ContactMap = () => {
  return (
    <section id="contact-page">
      <section className="map ">
        <MapComponent />
      </section>
    </section>
  );
};
